// extracted by mini-css-extract-plugin
export default {"column":"G6Z9kkdv","extra-small":"YICukFUR","item":"JB8yWYah","small":"Gq1Prhbi","medium":"DEo2bp0Z","large":"AK1urAZc"};